var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.version === null)?_c('div'):(_vm.version === 'v1')?_c('RegistroPontoUnidade'):_c('RegistroPontoNovo')
}
var staticRenderFns = []

export { render, staticRenderFns }